export default {
	"fe06c7d68480f0fa88aa753997d9cac2": "Sorry, the price has changed!",
	"fa27089ef054b4a53682eaa0249d2990": "System error. Please try again later",
	"4176f4a3daa3decf0f41f77c228867f5": "The signing failed. Please sign again"
}
